import styled from 'styled-components'
import colors from '../../theming/variables/colors'

export const SideMenu = styled.div`
  background-color: ${colors.white1};
  display: inline-block;
  min-height: 100vh;
  padding: 6rem 0;
  position: relative;
  max-width: 26rem;
  border-right: 0.1rem solid ${colors.gray2};
  width: ${(props) => (props.theme.collapsed ? 'auto' : '24rem')};
`
